<template>
<div>
  <FormulateInput class="formulateinput text-1sm"
    ref="ref"
    :type="type"
    :subtype="subtype"
    :name="name"
    :placeholder="label"
    :help="help"
    :validation="validation"
    v-model="value"
    :validationName="label"
    :validation-messages="validationCustomMessages"
    :validation-rules="validationCustomRules"
    input-class="skitude-input"
    input-has-errors-class="skitude-input-error"
    element-class="skitude-element"
    error-has-errors-class="skitude-validation"
    :show-errors="showError"
    :disabled="disabled"
    @input="updateValue"
  />
  <p v-if="explanation">{{ explanation}} </p>
  </div>
</template>

<script>
  export default {
    name: "ria-input",
    props: {
      name: String,
      label: String,
      type: String,
      help: String,
      subtype: String,
      validation: String,
      value: String,
      validationCustomMessages: Object,
      validationCustomRules: Object,
      explanation: String,
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        showError: false,
      }
    },
    computed: {
      valueProcessed() {
        return this.subtype === 'input-keycard'
          ? this.value.replace(/\s/g,'')
          : this.value;
      }
    },
    methods: {
      emitChangeValue: async function (value) {
        const hasErrors = value !== '' && await this.$refs.ref.hasValidationErrors();
        this.$emit("change", { field: this.name, value, hasErrors });
      },
      updateValue: async function (value) {
        this.value = value;
        await this.emitChangeValue(this.valueProcessed)
      },
      isValid: async function() {
        const hasValidationErrors = await this.$refs.ref.hasValidationErrors();
        return !hasValidationErrors
      }
    },
    async mounted() {
      await this.emitChangeValue(this.valueProcessed)
    }
  };
</script>

<style scoped>
  .formulateinput {
    @apply mb-3;
  }
</style>
